import { css, SerializedStyles } from '@emotion/react';

export const useStyles = () => ({
  whiteContentNormal: css({
    backgroundColor: "#ffffff",
    marginTop: "-10px",
    textAlign: "center",
    paddingTop: "24px",
  })
});
